// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-fee {
  padding: 4rem 2rem;
  background-color: #0C111B;
  background-image: linear-gradient(to bottom, #131b2c 0%, #0C111B 15%, #0C111B 85%, #131b2c 100%);
  position: relative;
  overflow: hidden;
  margin-top: -1px; /* Eliminate any gap between sections */
}

.course-fee::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: radial-gradient(circle at center, rgba(20, 241, 149, 0.03) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 0;
  animation: pulse-bg 10s ease-in-out infinite alternate;
}

/* Section transition elements */
.course-fee .section-transition-top {
  position: absolute;
  top: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);
  opacity: 0.5;
}

.course-fee .section-transition-bottom {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);
  opacity: 0.5;
}

.course-fee .section-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.course-fee .section-header h2 {
  font-size: 2.5rem;
  color: white;
  margin-bottom: 1rem;
  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.course-fee .section-header p {
  color: #9BA5B7;
  max-width: 600px;
  margin: 0 auto;
  font-size: 1.1rem;
}

.fee-container {
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 0;
  position: relative;
  z-index: 1;
}

.price-card {
  width: 350px;
  background: linear-gradient(145deg, #131b2c, #0e1520);
  border-radius: 16px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  padding: 2rem;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.price-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #9945FF, #14F195);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.price-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(153, 69, 255, 0.2);
}

.price-card:hover::before {
  opacity: 1;
}

.price-badge {
  position: absolute;
  top: 25px;
  right: -35px;
  background: linear-gradient(90deg, #9945FF, #14F195);
  color: #0C111B;
  padding: 0.5rem 3rem;
  font-weight: bold;
  transform: rotate(45deg);
  font-size: 0.8rem;
  z-index: 2;
  box-shadow: 0 5px 15px rgba(153, 69, 255, 0.3);
}

.price-card h3 {
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.price {
  text-align: center;
  margin-bottom: 1rem;
}

.amount {
  font-size: 3rem;
  font-weight: bold;
  color: #9945FF;
  text-shadow: 0 0 15px rgba(153, 69, 255, 0.4);
}

.currency {
  font-size: 1.2rem;
  color: #9BA5B7;
  margin-left: 0.5rem;
}

.price-description {
  text-align: center;
  color: #9BA5B7;
  margin-bottom: 2rem;
}

.price-features {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.price-features li {
  padding: 0.8rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  color: #9BA5B7;
  position: relative;
  padding-left: 1.5rem;
}

.price-features li:last-child {
  border-bottom: none;
}

.price-features li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #9945FF;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(153, 69, 255, 0.6);
}

.price-card .btn {
  width: 100%;
  padding: 1rem;
  font-size: 1.1rem;
  background: linear-gradient(90deg, #9945FF, #14F195);
  border: none;
  color: #0C111B;
  font-weight: bold;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(153, 69, 255, 0.3);
}

.price-card .btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(153, 69, 255, 0.4);
}

/* Course Schedule Styles */
.course-schedule {
  padding: 4rem 2rem;
  background-color: #131b2c;
  background-image: linear-gradient(to bottom, #0C111B 0%, #131b2c 15%, #131b2c 85%, #0C111B 100%);
  position: relative;
  overflow: hidden;
  margin-top: -1px; /* Eliminate any gap between sections */
}

.course-schedule::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: radial-gradient(circle at center, rgba(153, 69, 255, 0.03) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 0;
  animation: pulse-bg 10s ease-in-out infinite alternate;
}

/* Section transition elements */
.course-schedule .section-transition-top {
  position: absolute;
  top: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);
  opacity: 0.5;
}

.course-schedule .section-transition-bottom {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);
  opacity: 0.5;
}

.course-schedule .section-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.course-schedule .section-header h2 {
  font-size: 2.5rem;
  color: white;
  margin-bottom: 1rem;
  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.course-schedule .section-header p {
  color: #9BA5B7;
  max-width: 600px;
  margin: 0 auto;
  font-size: 1.1rem;
}

.schedule-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 0;
  position: relative;
  z-index: 1;
}

.batches {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1.5rem;
  overflow-x: auto;
  padding: 0.5rem 0.25rem;
}

.batch-card {
  background: linear-gradient(145deg, #131b2c, #0e1520);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  flex: 1 1;
  min-width: 250px;
  max-width: 300px;
}

.batch-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #9945FF, #14F195);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.batch-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(153, 69, 255, 0.2);
}

.batch-card:hover::before {
  opacity: 1;
}

.batch-card.full {
  background: linear-gradient(145deg, #111827, #0c1219);
  opacity: 0.8;
}

.batch-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.batch-header h3 {
  margin: 0;
  color: white;
  font-size: 1.3rem;
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.batch-status {
  padding: 0.3rem 0.7rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: bold;
}

.batch-status.full {
  background-color: rgba(255, 255, 255, 0.1);
  color: #9BA5B7;
}

.batch-status.available {
  background-color: rgba(20, 241, 149, 0.15);
  color: #14F195;
  text-shadow: 0 0 10px rgba(20, 241, 149, 0.4);
}

.batch-status.new {
  background-color: rgba(153, 69, 255, 0.15);
  color: #9945FF;
  text-shadow: 0 0 10px rgba(153, 69, 255, 0.4);
}

.batch-details {
  margin-bottom: 1.5rem;
}

.batch-date, .batch-slots {
  margin-bottom: 1rem;
  color: #9BA5B7;
}

.progress-bar {
  height: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  margin-top: 0.5rem;
  overflow: hidden;
}

.progress {
  height: 100%;
  background: linear-gradient(90deg, #14F195, #9945FF);
  transition: width 0.3s ease;
  box-shadow: 0 0 10px rgba(20, 241, 149, 0.4);
}

.btn.disabled {
  background-color: rgba(255, 255, 255, 0.1);
  color: #9BA5B7;
  cursor: not-allowed;
  box-shadow: none;
}

@media (max-width: 768px) {
  .course-fee, .course-schedule {
    padding: 3rem 1rem;
  }
  
  .batches {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .batch-card {
    margin-bottom: 1.5rem;
  }
}

/* WeChat Modal Styles */
.wechat-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.3s ease-out;
}

.wechat-modal-content {
  background: linear-gradient(145deg, #131b2c, #0e1520);
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  padding: 2rem;
  position: relative;
  width: 320px;
  max-width: 90%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  animation: scaleIn 0.3s ease-out;
}

.close-modal-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  color: #9BA5B7;
  font-size: 1.5rem;
  cursor: pointer;
  transition: color 0.2s ease;
}

.close-modal-btn:hover {
  color: #14F195;
}

.wechat-modal-content h3 {
  color: white;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.wechat-qr-container {
  padding: 1rem;
  background-color: white;
  border-radius: 8px;
  margin: 0 auto 1.5rem;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.wechat-qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.wechat-modal-content p {
  color: #9BA5B7;
  font-size: 0.9rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/CourseSchedule.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gGAAgG;EAChG,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gGAAgG;EAChG,UAAU;EACV,sDAAsD;AACxD;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,4EAA4E;AAC9E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,oDAAoD;EACpD,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,oDAAoD;EACpD,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gGAAgG;EAChG,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gGAAgG;EAChG,UAAU;EACV,sDAAsD;AACxD;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,qDAAqD;EACrD,2CAA2C;EAC3C,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,4EAA4E;AAC9E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".course-fee {\n  padding: 4rem 2rem;\n  background-color: #0C111B;\n  background-image: linear-gradient(to bottom, #131b2c 0%, #0C111B 15%, #0C111B 85%, #131b2c 100%);\n  position: relative;\n  overflow: hidden;\n  margin-top: -1px; /* Eliminate any gap between sections */\n}\n\n.course-fee::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  right: -50%;\n  bottom: -50%;\n  background: radial-gradient(circle at center, rgba(20, 241, 149, 0.03) 0%, rgba(0, 0, 0, 0) 70%);\n  z-index: 0;\n  animation: pulse-bg 10s ease-in-out infinite alternate;\n}\n\n/* Section transition elements */\n.course-fee .section-transition-top {\n  position: absolute;\n  top: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);\n  opacity: 0.5;\n}\n\n.course-fee .section-transition-bottom {\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);\n  opacity: 0.5;\n}\n\n.course-fee .section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  position: relative;\n  z-index: 1;\n}\n\n.course-fee .section-header h2 {\n  font-size: 2.5rem;\n  color: white;\n  margin-bottom: 1rem;\n  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.course-fee .section-header p {\n  color: #9BA5B7;\n  max-width: 600px;\n  margin: 0 auto;\n  font-size: 1.1rem;\n}\n\n.fee-container {\n  display: flex;\n  justify-content: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 0;\n  position: relative;\n  z-index: 1;\n}\n\n.price-card {\n  width: 350px;\n  background: linear-gradient(145deg, #131b2c, #0e1520);\n  border-radius: 16px;\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);\n  padding: 2rem;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.price-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, #9945FF, #14F195);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.price-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(153, 69, 255, 0.2);\n}\n\n.price-card:hover::before {\n  opacity: 1;\n}\n\n.price-badge {\n  position: absolute;\n  top: 25px;\n  right: -35px;\n  background: linear-gradient(90deg, #9945FF, #14F195);\n  color: #0C111B;\n  padding: 0.5rem 3rem;\n  font-weight: bold;\n  transform: rotate(45deg);\n  font-size: 0.8rem;\n  z-index: 2;\n  box-shadow: 0 5px 15px rgba(153, 69, 255, 0.3);\n}\n\n.price-card h3 {\n  color: white;\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.price {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.amount {\n  font-size: 3rem;\n  font-weight: bold;\n  color: #9945FF;\n  text-shadow: 0 0 15px rgba(153, 69, 255, 0.4);\n}\n\n.currency {\n  font-size: 1.2rem;\n  color: #9BA5B7;\n  margin-left: 0.5rem;\n}\n\n.price-description {\n  text-align: center;\n  color: #9BA5B7;\n  margin-bottom: 2rem;\n}\n\n.price-features {\n  list-style: none;\n  padding: 0;\n  margin-bottom: 2rem;\n}\n\n.price-features li {\n  padding: 0.8rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  color: #9BA5B7;\n  position: relative;\n  padding-left: 1.5rem;\n}\n\n.price-features li:last-child {\n  border-bottom: none;\n}\n\n.price-features li::before {\n  content: \"✓\";\n  position: absolute;\n  left: 0;\n  color: #9945FF;\n  font-weight: bold;\n  text-shadow: 0 0 8px rgba(153, 69, 255, 0.6);\n}\n\n.price-card .btn {\n  width: 100%;\n  padding: 1rem;\n  font-size: 1.1rem;\n  background: linear-gradient(90deg, #9945FF, #14F195);\n  border: none;\n  color: #0C111B;\n  font-weight: bold;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 15px rgba(153, 69, 255, 0.3);\n}\n\n.price-card .btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 20px rgba(153, 69, 255, 0.4);\n}\n\n/* Course Schedule Styles */\n.course-schedule {\n  padding: 4rem 2rem;\n  background-color: #131b2c;\n  background-image: linear-gradient(to bottom, #0C111B 0%, #131b2c 15%, #131b2c 85%, #0C111B 100%);\n  position: relative;\n  overflow: hidden;\n  margin-top: -1px; /* Eliminate any gap between sections */\n}\n\n.course-schedule::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  right: -50%;\n  bottom: -50%;\n  background: radial-gradient(circle at center, rgba(153, 69, 255, 0.03) 0%, rgba(0, 0, 0, 0) 70%);\n  z-index: 0;\n  animation: pulse-bg 10s ease-in-out infinite alternate;\n}\n\n/* Section transition elements */\n.course-schedule .section-transition-top {\n  position: absolute;\n  top: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);\n  opacity: 0.5;\n}\n\n.course-schedule .section-transition-bottom {\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);\n  opacity: 0.5;\n}\n\n.course-schedule .section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  position: relative;\n  z-index: 1;\n}\n\n.course-schedule .section-header h2 {\n  font-size: 2.5rem;\n  color: white;\n  margin-bottom: 1rem;\n  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.course-schedule .section-header p {\n  color: #9BA5B7;\n  max-width: 600px;\n  margin: 0 auto;\n  font-size: 1.1rem;\n}\n\n.schedule-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 0;\n  position: relative;\n  z-index: 1;\n}\n\n.batches {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 1.5rem;\n  overflow-x: auto;\n  padding: 0.5rem 0.25rem;\n}\n\n.batch-card {\n  background: linear-gradient(145deg, #131b2c, #0e1520);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  position: relative;\n  flex: 1;\n  min-width: 250px;\n  max-width: 300px;\n}\n\n.batch-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, #9945FF, #14F195);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.batch-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(153, 69, 255, 0.2);\n}\n\n.batch-card:hover::before {\n  opacity: 1;\n}\n\n.batch-card.full {\n  background: linear-gradient(145deg, #111827, #0c1219);\n  opacity: 0.8;\n}\n\n.batch-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.batch-header h3 {\n  margin: 0;\n  color: white;\n  font-size: 1.3rem;\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.batch-status {\n  padding: 0.3rem 0.7rem;\n  border-radius: 50px;\n  font-size: 0.8rem;\n  font-weight: bold;\n}\n\n.batch-status.full {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #9BA5B7;\n}\n\n.batch-status.available {\n  background-color: rgba(20, 241, 149, 0.15);\n  color: #14F195;\n  text-shadow: 0 0 10px rgba(20, 241, 149, 0.4);\n}\n\n.batch-status.new {\n  background-color: rgba(153, 69, 255, 0.15);\n  color: #9945FF;\n  text-shadow: 0 0 10px rgba(153, 69, 255, 0.4);\n}\n\n.batch-details {\n  margin-bottom: 1.5rem;\n}\n\n.batch-date, .batch-slots {\n  margin-bottom: 1rem;\n  color: #9BA5B7;\n}\n\n.progress-bar {\n  height: 8px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  margin-top: 0.5rem;\n  overflow: hidden;\n}\n\n.progress {\n  height: 100%;\n  background: linear-gradient(90deg, #14F195, #9945FF);\n  transition: width 0.3s ease;\n  box-shadow: 0 0 10px rgba(20, 241, 149, 0.4);\n}\n\n.btn.disabled {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #9BA5B7;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n@media (max-width: 768px) {\n  .course-fee, .course-schedule {\n    padding: 3rem 1rem;\n  }\n  \n  .batches {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  \n  .batch-card {\n    margin-bottom: 1.5rem;\n  }\n}\n\n/* WeChat Modal Styles */\n.wechat-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n  animation: fadeIn 0.3s ease-out;\n}\n\n.wechat-modal-content {\n  background: linear-gradient(145deg, #131b2c, #0e1520);\n  border-radius: 16px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);\n  padding: 2rem;\n  position: relative;\n  width: 320px;\n  max-width: 90%;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  text-align: center;\n  animation: scaleIn 0.3s ease-out;\n}\n\n.close-modal-btn {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: none;\n  border: none;\n  color: #9BA5B7;\n  font-size: 1.5rem;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.close-modal-btn:hover {\n  color: #14F195;\n}\n\n.wechat-modal-content h3 {\n  color: white;\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.wechat-qr-container {\n  padding: 1rem;\n  background-color: white;\n  border-radius: 8px;\n  margin: 0 auto 1.5rem;\n  width: 200px;\n  height: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n.wechat-qr-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.wechat-modal-content p {\n  color: #9BA5B7;\n  font-size: 0.9rem;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
